import { Routes, Route } from "react-router-dom";

import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/home/Home";
import Footer from "./components/footer/Footer";
import About from "./components/about/About";
import GoToTop from "./components/GoToTop";
import InstCenters from "./components/centers/InstCenters";
import TrackingServicesDetails from "./components/services/TrackingServicesDetails";
import Documents from "./components/documents/Documents";

import { ToastContainer } from "react-toastify";

import GigaBot from "./components/GigaBot/GigaBot";
import CybersecurityServicesDetails from "./components/services/CybersecurityServicesDetails";
import SoftwareDevServicesDetails from "./components/services/SoftwareDevServicesDetails";
import NetworkServicesDetails from "./components/services/NetworkServicesDetails";
import CloudServicesDetails from "./components/services/CloudServicesDetails";
import SystemIntegrationServicesDetails from "./components/services/SystemIntegrationServicesDetails";
import CookieConsent from "react-cookie-consent";
import { t } from "i18next";
import Reservation from "./components/reservation/Reservation";
import { useContext, useEffect, useState } from "react";
import RequireAuth, {
  verifyTokenWithBackend,
} from "./backendServices/RequireAuth";
import Login from "./components/userBookingLogic/login/Login";
import Register from "./components/userBookingLogic/register/Register";
import Dashboard from "./components/userBookingLogic/Dashboard";
import AppointmentForm from "./components/userBookingLogic/book/AppointmentForm";
import Applications from "./components/apps/Applications";
import Cookies from "js-cookie";
import VerifyEmail from "./components/userBookingLogic/VerifyEmail";
import CareerPage from "./components/career/CareerPage";
import { visitorLocationService } from "./backendServices/visitorLocationService";
import CustomerHeatmap from "./components/heatmap/CustomerHeatmap";
import ServiceNotAvailable from "./components/serviceNotAvailable/ServiceNotAvailable";
import { Context } from "./components/LocalWrapper";
import PrivacyPolicyModal from "./components/about/privacyPolicy/privacyPolicyModal/PrivacyPolicyModal";
import RequiredDocs from "./components/documents/RequiredDocs";
import FmsSoftware from "./components/apps/FmsSoftware";
// import BusinessCard from "./components/about/BusinessCard/BusinessCard";
const authed = async (token) => await verifyTokenWithBackend(token);

function App() {
  const [token, setToken] = useState("");
  const context = useContext(Context);

  // const [location, setLocation] = useState({ lat: null, long: null });

  useEffect(() => {
    setToken(Cookies.get("authToken"));
  }, [token]);

  // Function to get the user's geolocation

  const getLocation = async () => {
    if (navigator.geolocation) {
      // setIsLoading(true); // Start loading state

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const long = position.coords.longitude;

          // Update state with location data
          // setLocation({ lat, long });

          // console.log("Latitude:", lat);
          // console.log("Longitude:", long);
          if (lat && long) {
            try {
              // Call the backend service to save the location
              const response = await saveVisitorLocationService({ lat, long });
              console.log("Loc svd :", response?.data?.message || "");
            } catch (error) {
              console.error("Error svg loc:", error);
            } finally {
              // setIsLoading(false); // End loading state
            }
          }
        },
        (error) => {
          if (error.code === 1) {
            console.log(
              "Geolocation access denied. Please allow location access or use HTTPS."
            );
          } else if (error.code === 2) {
            console.log("Location unavailable. Check your connection or GPS.");
          } else if (error.code === 3) {
            console.log("Geolocation timed out. Please try again.");
          } else {
            console.log("An unknown error occurred.");
          }
          console.error("Geolocation error:", error);
          // setIsLoading(false); // End loading state
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  // useEffect(() => {
  //   getLocation();
  // }, []);

  const saveVisitorLocationService = async (locationData) => {
    // Example API call to save location (replace with actual API endpoint)
    const response = await visitorLocationService(locationData);
    return response;
  };

  return (
    <div className="App">
      <Navbar />
      <ToastContainer />

      <CookieConsent
        dir="ltr"
        location="bottom"
        enableDeclineButton
        flipButtons
        buttonText={t("cookies_acceptBtn")}
        declineButtonText={t("cookies_declinedBtn")}
        cookieName="myAwesomeCookieName2"
        style={{ background: "#2B373B", width: "400px", margin: "30px" }}
        buttonStyle={{ color: "#4e503b" }}
        // expires={1}
        onAccept={getLocation}
      >
        {t("cookies_pragraph")}
        <br />
        <div className="privacy-policy-link">
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <PrivacyPolicyModal pp_title={"cookies_policy"} />
          </span>
        </div>
      </CookieConsent>

      {/* <GigaBot1 /> */}
      <GigaBot />
      <Routes>
        {/* ********** booking and user registering section ************** */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route element={<RequireAuth />}>
          <Route path="/dashboard" element={<Dashboard token={token} />} />
          <Route path="/book" element={<AppointmentForm token={token} />} />

          <Route path="/career" element={<CareerPage token={token} />} />
          <Route
            path="/cust-heat-map"
            element={<CustomerHeatmap token={token} />}
          />
        </Route>
        {/* ********** ************************************ ************** */}
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/fmsSoftware" element={<FmsSoftware />} />
        {/* <Route path="/bcd/:id" element={<BusinessCard />} /> */}
        <Route path="/centers" element={<InstCenters />} />
        {/* ******************* services details ******************* */}
        <Route
          path="/tracking-services-det"
          element={<TrackingServicesDetails />}
        />
        <Route
          path="/cyber-security-services-det"
          element={<ServiceNotAvailable />}
        />
        <Route
          path="/software-development-services-det"
          element={<ServiceNotAvailable />}
        />
        <Route
          path="/network-services-det"
          element={<NetworkServicesDetails />}
        />
        <Route
          path="/system-integration-services-det"
          element={<SystemIntegrationServicesDetails />}
        />
        <Route path="/cloud-services-det" element={<ServiceNotAvailable />} />
        {/* <Route path="/documents" element={<Documents />} /> */}
        <Route path="/documents" element={<RequiredDocs />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route
          path="/service-not-available"
          element={<ServiceNotAvailable />}
        />
        <Route path="*" element={<Home />} />{" "}
        {/* Fallback for undefined routes */}
      </Routes>
      <GoToTop />
      <Footer />
    </div>
  );
}

export default App;
